(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("9asrW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6acb1dbe08e2d449$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $6acb1dbe08e2d449$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function ModalOpener(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, ModalOpener);
        this.el = el;
        this.isLargeQuery = isLargeQuery;
        this.init();
    }
    (0, $hvJJn._)(ModalOpener, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.el.addEventListener('click', function(e) {
                    e.preventDefault();
                    // get data modal attribute
                    var modalId = _this.el.getAttribute('data-modal');
                    var modalEl = document.getElementById(modalId);
                    if (modalId && modalId !== 'false') {
                        // open modal
                        document.body.style.overflow = 'hidden';
                        modalEl.classList.add('active');
                    }
                });
            }
        }
    ]);
    return ModalOpener;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=ModalOpener.3a5ccaff.js.map
